export class FaqsModel {

    constructor(id, question, answer) {
        this.id = id;
        this.question = question;
        this.answer = answer;
    };

};